import axios from '../api/axiosInstance';

// Expense Types
export const fetchExpenseTypes = (params) => axios.get('/expense-types', { params });

export const createExpenseType = (data) => axios.post('/expense-types', data);

export const updateExpenseType = (id, data) => axios.patch(`/expense-types/${id}`, data);

export const updateExpenseTypeStatus = (id, isActive) =>
  axios.patch(`/expense-types/${id}/status`, { isActive });

export const deleteExpenseType = (id) => axios.delete(`/expense-types/${id}`);

// Expenses
export const fetchExpenses = (params) => axios.get('/expenses', { params });

export const createExpense = (data) => axios.post('/expenses', data);

export const updateExpense = (id, data) => axios.patch(`/expenses/${id}`, data);

export const deleteExpense = (id) => axios.delete(`/expenses/${id}`);

export const getExpense = (id) => axios.get(`/expenses/${id}`);
